import JazzIcon from './Jazz'

export default JazzIcon
